import React from "react";

import {KomisApp} from "../components/KomisApp/KomisApp";

export const KomisAppView = () => <KomisApp/>;